var _path, _path2, _path3, _g, _g2, _g3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 40c0 5.5-4.5 10-10 10H12C6.5 50 2 45.5 2 40V10C2 4.5 6.5 0 12 0h40c5.5 0 10 4.5 10 10v30z",
    fill: "#44618b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7 26.3c0 1.5-1.2 2.7-2.7 2.7H9.2c-1.5 0-2.7-1.2-2.7-2.7V8.2c0-1.5 1.2-2.7 2.7-2.7H47c1.5 0 2.7 1.2 2.7 2.7v18.1z",
    fill: "#cad5dd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7 28c0 1.5-1.2 2.7-2.7 2.7H9.2c-1.5 0-2.7-1.2-2.7-2.7V9.9c0-1.5 1.2-2.7 2.7-2.7H47c1.5 0 2.7 1.2 2.7 2.7V28z",
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4 26.2h2l-4-14.4h-2l-4 14.4h2l1.3-4.7h3.6l1.1 4.7M16 19.7l1.3-4.6l1.3 4.6H16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9 11.8v1.8H25v12.6h1.9V13.6H31v-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3 26.2V16.1L37 26.2h2.5l2.7-10.1v10.1H44V11.8h-2.5l-3.3 12.1L35 11.8h-2.5v14.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#2b4666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2 34.4c0-1.1.9-2 2-2H62v7h-4.8c-1.1 0-2-.9-2-2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2 24c0-1.1.9-2 2-2H62v7h-4.8c-1.1 0-2-.9-2-2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2 13.6c0-1.1.9-2 2-2H62v7h-4.8c-1.1 0-2-.9-2-2v-3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#42ade2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2 33.4c0-1.1.9-2 2-2H62v7h-4.8c-1.1 0-2-.9-2-2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2 23c0-1.1.9-2 2-2H62v7h-4.8c-1.1 0-2-.9-2-2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2 12.6c0-1.1.9-2 2-2H62v7h-4.8c-1.1 0-2-.9-2-2v-3"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 37.2c0 1.4-1.1 2.5-2.5 2.5H9c-1.4 0-2.5-1.1-2.5-2.5v-.9c0-1.4 1.1-2.5 2.5-2.5h29.5c1.4 0 2.5 1.1 2.5 2.5v.9",
    fill: "#333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#83bf4f",
    d: "M38.6 36l6.9 28.1H2L8.9 36z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#699635",
    d: "M37 36l5.7 25.9H4.8L10.5 36z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#83bf4f",
    d: "M36 36l4.9 24.5H6.6L11.5 36z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 40.7L22 52.1c0 1.3-1.3 2.3-2.8 2.3c-1.5 0-2.6-1.1-2.5-2.3l1.1-11.5c.1-.9 1.1-1.6 2.3-1.6l.1-2c-2.7 0-5.2 1.6-5.5 3.6l-.6 4H11l-.5 2.5h3.3l-.7 4.9c-.4 3 2.2 5.6 5.9 5.6s6.6-2.6 6.5-5.6l-.3-11.5c0-.9.9-1.6 2.2-1.6s2.3.7 2.3 1.6L30.8 52c.1 1.3-1 2.3-2.5 2.3l.2 3.3c3.7 0 6.3-2.6 5.9-5.6l-.7-4.9H37l-.5-2.5h-3.2l-.6-4c-.3-2-2.7-3.6-5.5-3.6s-4.9 1.6-5 3.7",
    fill: "#699635"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtm);
export default __webpack_public_path__ + "static/media/atm.833095f663ad0e2d6b16283930a69ebd.svg";
export { ForwardRef as ReactComponent };